function isPositiveNumber(value: unknown): boolean {
	return /^\s*(?=.*[1-9])\d*(?:(\.|,)\d{1,1000})?\s*$/.test(String(value));
}

export default isPositiveNumber;
